
<script setup>
import Icon from '@components/Icon.vue'
</script>


<template>
    <div class="staff-profile-loader">
        <div class="staff-profile-loader__header">
            <div v-for="i in 2" class="staff-profile-loader__header-image"></div>
        </div>
        <div class="staff-profile-loader__content">
            <div class="staff-profile-loader__avatar">
                <Icon name="user01" size="48px"></Icon>
            </div>
            <div class="staff-profile-loader__placeholder staff-profile-loader__placeholder--name"></div>
            <div class="staff-profile-loader__placeholder staff-profile-loader__placeholder--title"></div>
            <div class="staff-profile-loader__placeholder staff-profile-loader__placeholder--subtitle"></div>
            <div class="staff-profile-loader__placeholder staff-profile-loader__placeholder--text-full"></div>
            <div class="staff-profile-loader__placeholder staff-profile-loader__placeholder--text-partial"></div>
        </div>
    </div>
</template>

<style>

</style>